import clsx from 'clsx';
import React from 'react';

type ContentSectionProps = {
  bg?: 'white' | 'gray';
  children: React.ReactNode;
  fullWidth?: boolean;
};

export function ContentSection({ bg = 'gray', children, fullWidth = false }: ContentSectionProps) {
  return (
    <section
      className={clsx(
        'flex flex-col w-full p-9',
        bg == 'gray' ? 'bg-gray-100' : 'bg-white',
        !fullWidth && 'md:w-2/3'
      )}
    >
      {children}
    </section>
  );
}
